console.log('[Boot] main.tsx executing');

import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import "leaflet/dist/leaflet.css";
import "./mobile.css";
import "./capacitor-ios.css";
import "./capacitor-android.css";
import { initSentry } from "./lib/monitoring";
import { initAppLifecycle } from "./lib/appLifecycle";
import { initWebVitals } from "./lib/webVitals";
import { initCapacitorPlugins } from "./lib/capacitorInit";
import { applyCapacitorClasses } from "./lib/capacitorPlatform";
import { initCapacitorKeyboard } from "./lib/capacitorKeyboard";
import { initMobileFormScroll } from "./lib/mobileFormScroll";
import { initCapacitorUpdater } from "./lib/capacitorUpdater";
import { initDeepLinkListener } from "./lib/deepLinkRouter";
import { Capacitor } from "@capacitor/core";

// Global error handler to catch uncaught JS exceptions (surfaces "JS Eval error" details)
window.addEventListener('error', (e) => {
  console.error(`[Boot][UNCAUGHT] ${e.message} | file=${e.filename}:${e.lineno}:${e.colno}`);
});
window.addEventListener('unhandledrejection', (e) => {
  console.error(`[Boot][UNHANDLED_PROMISE] ${e.reason}`);
});

// Initialize monitoring services
try { initSentry(); } catch (e) { console.error('[Boot] initSentry failed:', e); }
try { initWebVitals(); } catch (e) { console.error('[Boot] initWebVitals failed:', e); }
try { initCapacitorPlugins(); } catch (e) { console.error('[Boot] initCapacitorPlugins failed:', e); }
try { applyCapacitorClasses(); } catch (e) { console.error('[Boot] applyCapacitorClasses failed:', e); }
try { initCapacitorKeyboard(); } catch (e) { console.error('[Boot] initCapacitorKeyboard failed:', e); }
try { initMobileFormScroll(); } catch (e) { console.error('[Boot] initMobileFormScroll failed:', e); }
try { initAppLifecycle(); } catch (e) { console.error('[Boot] initAppLifecycle failed:', e); }
try { initCapacitorUpdater(); } catch (e) { console.error('[Boot] initCapacitorUpdater failed:', e); }
try { initDeepLinkListener(); } catch (e) { console.error('[Boot] initDeepLinkListener failed:', e); }

console.log('[Boot] all init functions completed');

// Prevent browser/WKWebView from auto-restoring scroll positions
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

createRoot(document.getElementById("root")!).render(
  <App />
);

// Hide native splash screen after page fully loads to prevent white flash
if (Capacitor.isNativePlatform()) {
  const hideSplash = () => {
    setTimeout(() => {
      import("@capacitor/splash-screen").then(({ SplashScreen }) => {
        SplashScreen.hide({ fadeOutDuration: 300 });
      }).catch(() => {});
    }, 300);
  };
  if (document.readyState === 'complete') {
    hideSplash();
  } else {
    window.addEventListener('load', hideSplash, { once: true });
  }
}
